/* Keep */
import { productSelectors } from '@ynap/product-state';

const { getProductLinkByPartNumber, getBuyableStatus } = productSelectors;

export const getColourSwatches = (productColours, pdpUrlTemplate, locale, user, messages) => {
    return productColours.map((colour) => {
        const { seo, partNumber, selected, swatch, label } = colour;
        const buyableStatus = getBuyableStatus({
            selectedProduct: colour,
            user,
            locale,
            messages,
        });

        return {
            partNumber,
            swatch: swatch && {
                URL: swatch.URL?.replace('{width}', '50'),
                HEX: swatch.HEX,
            },
            label,
            selected,
            href: getProductLinkByPartNumber(pdpUrlTemplate, locale, seo, partNumber),
            notBuyable: !buyableStatus.canAddToBag,
        };
    });
};
